import { GeneralTypes } from '../ActionTypes/GeneralTypes'

class GeneralAction {
    static ShowLoading = () => {
        return {
            type: GeneralTypes.SHOW_LOADING,
        };
    };
    static HideLoading = () => {
        return {
            type: GeneralTypes.HIDE_LOADING,
        };
    };

}

export default GeneralAction;